import React, { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { useLanguage } from "./LanguageContext";

const AdminDashboardHeader = (props) => {

    const [navOpen, setNavOpen] = useState(false);

    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useOutletContext(false);

    const { language, changeLanguage } = useLanguage();

    const handleLogoClick = () => {
        window.open("/", "_self");
    }

    const handleLogoutClick = () => {
        const response = fetch(`${process.env.REACT_APP_API_URL}/admin/logout`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ 
                token: window.localStorage.getItem('adminToken'),
                token_expiry: window.localStorage.getItem('adminTokenExpiry') 
            }),
          })
          .then(response => response.json())
          .then(data => {
               // Handle successful logout
                window.localStorage.removeItem('adminToken');
                window.localStorage.removeItem('adminTokenExpiry');
                navigate("/", "_self");
                console.log("Admin logged out successfully");
          })
          .catch(error => {
              console.error("Error occurred during admin logout:", error);
          });
    }

    return (
       <header className="mobile-header">
            <div className="header-row">
                <img
                    onClick={handleLogoClick}
                    src="https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/boggler-logo-clear.webp"
                    alt="Boggler Logo"
                    className="header-logo"
                    loading="lazy"
                    style={{ borderRadius: 8 }}
                />
            <button
                className="hamburger"
                aria-label="Open navigation"
                onClick={() => setNavOpen(!navOpen)}
            >
                <span className="bar" />
                <span className="bar" />
                <span className="bar" />
            </button>
            </div>
            <nav className={`main-nav${navOpen ? " open" : " closed"}`}>
                <span className="header-button" onClick={() => { setNavOpen(false); navigate("/applicants")}}>Applicants</span>
                <span className="header-button" onClick={() => { setNavOpen(false); navigate("/archetypes")}}>Archetypes</span>
                <span className="header-button" onClick={() => { setNavOpen(false); navigate("/guides")}}>Guides</span>
                <span className="header-button" onClick={() => { setNavOpen(false); navigate("/payouts")}}>Payouts</span>
                <span className="header-button header-button-logout" onClick={handleLogoutClick}>Logout</span>
            </nav>
        </header>
    )
}

export default AdminDashboardHeader;